/*eslint-disable require-yield*/
import {
  put,
  fork,
  take,
  select,
  call,
  takeLatest
} from 'redux-saga/effects';
import { delay } from 'redux-saga';
import {LOCATION_CHANGE} from 'react-router-redux';
import jquery from 'jquery'; //eslint-disable-line no-unused-vars
import _ from 'lodash';
import {
  pageLoadActionsForRoute,
  pageLoadVarsForRoute
} from './dataLayerHelpers';
import {
  PAGE_LOADED,
  ANALYTICS_DATA_RECEIVED,
  ANALYTICS_ERRORS_RECEIVED,
  CUSTOM_EVENT_RECEIVED
} from './dataLayer';
import {
  navigationRoutes
} from '../navigation/navigationHelpers';
import {
  DL_ERROR_PAGE_LOADED,
  getErrorContentPath
} from '../pages/error/error';
import { noEndingSlash } from '../../../util/helpers';

// WATCHERS
export function* pageLoadedWatcher() {
  yield takeLatest(PAGE_LOADED, pageLoadedWorker);
}

export function* errorPageLoadedWatcher() {
  yield takeLatest(DL_ERROR_PAGE_LOADED, errorPageLoadedWorker);
}

export function* analyticsDataWatcher() {
  yield takeLatest(ANALYTICS_DATA_RECEIVED, analyticsDataWorker);
}

export function* errorsWatcher() {
  yield takeLatest(ANALYTICS_ERRORS_RECEIVED, errorsWorker);
}

export function* customEventWatcher() {
  // yield* throttle(100, CUSTOM_EVENT_RECEIVED, customEventWorker);
  // yield takeLatest(CUSTOM_EVENT_RECEIVED, customEventWorker);
  while (true) {
    const action = yield take(CUSTOM_EVENT_RECEIVED);

    yield fork(customEventWorker, action);
    // delay to prevent redundant subsequent calls
    yield call(delay, 100);
  }
}

export function* dataLayerFlow() {
  while (true) {
    const {payload: {pathname}} = yield take(LOCATION_CHANGE);
    const currentRoute = (currentPath) => navigationRoutes[_.findKey(navigationRoutes, route => {
      return noEndingSlash(_.toLower(currentPath)) === noEndingSlash(route.path);
    })];

    const routeKey = _.get(currentRoute(pathname), 'key');

    const pageLoadActions = pageLoadActionsForRoute(routeKey);

    if (_.isEmpty(pageLoadActions)) {
      continue;
    }

    yield take(pageLoadActions);

    const state = yield select();
    const pageLoadVars = pageLoadVarsForRoute(routeKey, state);
    const action = {
      type: PAGE_LOADED,
      payload: {
        pageLoadVars
      }
    };

    yield put(action);
  }
}

export function* errorPageLoadedWorker(payload) {
  const navStep = getErrorContentPath(payload.path);
  const state = yield select();
  const pageLoadVars = pageLoadVarsForRoute(navStep, state);
  const action = {
    type: PAGE_LOADED,
    payload: {
      pageLoadVars
    }
  };

  yield put(action);
}

export function* pageLoadedWorker({payload: {pageLoadVars}}) {
  jquery(document).trigger('c-tracking-log-page', pageLoadVars);
}

export function* errorsWorker({payload: {errorMessages}}) {
  if (_.isEmpty(errorMessages)) {
    return;
  }
  const errorMessage = errorMessages.join(' | ');
  const errorMessageEvent = {
    eventMethod: 'send-Error',
    errorMessage
  };

  jquery(document.body).trigger('c-tracking-log-dom', errorMessageEvent);
}

export function* customEventWorker({payload: {eventContent}}) {
  if (_.isEmpty(eventContent)) {
    return;
  }

  jquery(document.body).trigger('c-tracking-log-dom', eventContent);
}

export function* analyticsDataWorker({payload: {analyticsData}}) {
  const events = analyticsData.digitalData.events;

  _.forEach(events, function(analyticsItem) {
     analyticsItem = _.omitBy(analyticsItem, _.isNull); // would prefer null values to not be sent by the server
     jquery(document.body).trigger('c-tracking-log-dom', analyticsItem);
   });
}

export default function* dataLayerSagas() {
  yield [
    fork(dataLayerFlow),
    fork(errorPageLoadedWatcher),
    fork(pageLoadedWatcher),
    fork(analyticsDataWatcher),
    fork(errorsWatcher),
    fork(customEventWatcher)
  ];
}



/** WEBPACK FOOTER **
 ** ./client/redux/modules/dataLayer/dataLayerSagas.js
 **/